// utils
import intersection from 'lodash.intersection';
import { createSelector } from 'reselect';
import { isUntaggedDirectPost } from 'utils/activityHelper';

const mainFeedVarieties = [
  'health_issue',
  'media',
  'efficacy',
  'checked_in',
  'direct',
  'shared',
  'birthday_congrats',
  'diagnosis_encouragement',
  'media_encouragement',
  'low_mortality',
  'withdrawal_warning',
  'water_usage_warning',
  'svr_issue',
  'agent_withdrawal_warning',
  'agent_premarket_load_warning',
];

export const newActivitiesDefaultSelector = createSelector(
  (state) => state.farmfeed.newActivities.resources,
  (newActivities) => newActivities.filter((activity) => intersection(activity.variety, mainFeedVarieties).length),
);

// New activities the user will actually see, posts hidden by the "only tagged posts" preference excluded
export const newActivitiesVisibleSelector = createSelector(
  newActivitiesDefaultSelector,
  (state) => state.auth.user,
  (newActivities, user) => (user?.ff_hide_untagged_posts
    ? newActivities.filter((activity) => !isUntaggedDirectPost(activity, user))
    : newActivities),
);
